import React from 'react';
import moment from 'moment';
import EditableCell from '../editableCell/EditableCelll.component';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './DataTable.module.scss';
import {
  faEdit,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Dropdown } from 'react-bootstrap';
import { getRoleLabel } from '../../constants/roles';

const DataTable = ({
  tableData,
  tableheading,
  handleOnClick,
  tag,
  editableCell,
  handleAddRow,
  handleRemoveRow,
  fetchError,
  search_filter_loading,
  renderTableDropdown,
  notFoundMessage,
  merchant,
  renderTerminalsDropdown,
  expanded,
  loading,
  renderExpandableText,
  handleEditMerchant,
  handleEditVoucherTheme,
  handleEditProduct,
  handleDeleteProduct,
  handleUpdateProductFeatured,
  handleUpdateProductPublished,
  renderVoucherThemeImageCell,
  handleEditCategory,
  handleDeleteCategory,
  renderCategoryImageCell,

}) => {

  // Define safe fallbacks for tableheading and tableData.
  const safeTableHeading =
    tableheading && tableheading.column ? tableheading.column : [];
  const safeTableData = Array.isArray(tableData) ? tableData : [];

  // Renders table headings using safeTableHeading
  const renderTableHeadings = () => {
    return safeTableHeading.map((data, index) => (
      <th key={index} className={styles.tableHead} align='center'>
        {data}
      </th>
    ));
  };

  // ==============================
  // Row-level render functions
  // ==============================

  const renderUploadHistory = (data) => (
    <tr onClick={() => handleOnClick(data.batchId)} key={data.batchId}>
      <td>{data.batchId}</td>
      <td>{data.merchantVoucherStore}</td>
      <td>{moment(data.createdDate).format('DD/MM/YYYY hh:mm A')}</td>
      <td>{data.status}</td>
      <td>{data.uploadedBy}</td>
    </tr>
  );

  const truncateString = (str, num) => {
    if (!str) return '';
    return str.length <= num ? str : str.substring(0, num) + '...';
  };

  const renderTransactionHistory = (data) => (
    <tr
      onClick={() => handleOnClick(data.redemptionId)}
      key={data.redemptionId}
    >
      <td>{moment(data.timestamp).format('DD/MM/YYYY hh:mm A')}</td>
      <td>{truncateString(data.description, 25)}</td>
      <td>{truncateString(data.amount?.toFixed(2).toString(), 10)}</td>
    </tr>
  );

  const renderTransferredData = (data) => (
    <tr key={data.id}
      onClick={() => handleOnClick(data.id)}
    >
      <td>{moment(data.purchase.createdDate).format('DD/MM/YYYY hh:mm A')}</td>
      <td>{data.senderMobileNo}</td>
      <td>{data.mobileNo}</td>
      <td>{data?.admin?.email ? data?.admin?.email : 'N/A'}</td>
    </tr>
  );

  const renderProductDetails = (data) => (
    <tr key={data.id} className={styles.productRow}>
      <td style={{ position: 'relative', width: '50px' }}>
        {data.id}
      </td>
      <td>{data.category}</td>
      <td>{data.title}</td>
      <td>
        {(() => {
          const themes = Array.isArray(data.themes) ? data.themes : [];
          /*  
          Filter to themes where `default` is strictly true 
          */
          const defaultThemes = themes.filter((theme) => theme?.default === true);
          if (defaultThemes.length > 0) {
            return defaultThemes.map((theme, index) => (
              <img
                key={theme.id || index}
                src={theme.thumbnail}
                alt={`${data.title} Theme ${index + 1}`}
                style={{
                  width: '200px',
                  height: '120px',
                  objectFit: 'scale-down',
                  borderRadius: '4px',
                  marginRight: '8px',
                }}
              />
            ));
          }

          // Fallback: if there are themes but none marked default, show 'N/A'
          return 'N/A';
        })()}
      </td>
      <td>
        <Dropdown>
          <Dropdown.Toggle
            variant={data.featured ? 'success' : 'secondary'}
            size="sm"
            className={styles.statusDropdown}
          >
            {data.featured ? 'Featured' : 'UnFeatured'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {
              data.featured ? (
                <Dropdown.Item onClick={() => handleUpdateProductFeatured({ ...data, featured: false })}>UnFeature</Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={() => handleUpdateProductFeatured({ ...data, featured: true })}>Feature</Dropdown.Item>
              )
            }
          </Dropdown.Menu>
        </Dropdown>
      </td>
      <td>
        <Dropdown>
          <Dropdown.Toggle
            variant={data.published ? 'success' : 'secondary'}
            size="sm"
            className={styles.statusDropdown}
          >
            {data.published ? 'Published' : 'UnPublished'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {
              data.published ? (
                <Dropdown.Item onClick={() => handleUpdateProductPublished({ ...data, published: false })}>UnPublish</Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={() => handleUpdateProductPublished({ ...data, published: true })}>Publish</Dropdown.Item>
              )
            }
          </Dropdown.Menu>
        </Dropdown>
      </td>
      <td>
        {data.slug}

        <div className={styles.actionIconsContainer}>
          {handleEditProduct && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleEditProduct(data);
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-edit-${data.id}`}>Edit Product</Tooltip>}
              >
                <span className={styles.editIcon}>
                  <FontAwesomeIcon icon={faEdit} />
                </span>
              </OverlayTrigger>
            </div>
          )}

          {handleDeleteProduct && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteProduct(data);
              }}
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-delete-${data.id}`}>Delete Product</Tooltip>}
              >
                <span className={styles.deleteIcon}>
                  <FontAwesomeIcon icon={faTrash} />
                </span>
              </OverlayTrigger>
            </div>
          )}
        </div>
      </td>
    </tr>
  );

  const renderProductCategoryDetails = (data) => (
    <tr key={data.id} className={styles.voucherThemeRow}>
      <td>{data.category}</td>
      <td>{data.displayOrder}</td>
      <td>{data.status}</td>
      <td>
        {renderCategoryImageCell
          ? renderCategoryImageCell(data.bannerImg1 || data.bannerImg2)
          : data.bannerImg1 || data.bannerImg2}
      </td>
      <td>{data.displayTitle}</td>
      <td>{data.subTitle}
        {handleEditCategory && (
          <div
            className={styles.editIconContainer}
            onClick={(e) => {
              e.stopPropagation();
              handleEditCategory(data);
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-edit-${data.id}`}>Edit Category</Tooltip>}
            >
              <span>
                <FontAwesomeIcon icon={faEdit} />
              </span>
            </OverlayTrigger>
          </div>
        )}
      </td>
    </tr>
  );


  const renderUserDetails = (data) => (
    <tr key={data.email}>
      <td>{data.firstName}</td>
      <td>{data.lastName}</td>
      <td>{data.email}</td>
      <td>{data.mobileNo}</td>
    </tr>
  );

  const renderAdminUserData = (data) => (
    <tr
      key={data.id}
      onClick={() => data.subMerchant && handleOnClick(data.id)}
      style={{ cursor: data.subMerchant ? 'pointer' : 'default' }}
    >
      <td>{data.email}</td>
      <td>{getRoleLabel(data.role)}</td>
      <td>{data.mobile || 'N/A'}</td>
    </tr>
  );

  const renderVoucherDetails = (data) => (
    <tr onClick={() => handleOnClick(data.id)} key={data.id}>
      <td>{data.id}</td>
      <td>{data.ownerName}</td>
      <td>{data.sender}</td>
      <td>
        {data.amount
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </td>
      <td>{data.ownerMobile}</td>
    </tr>
  );

  const renderVoucherThemes = (data) => (
    <tr key={data.id} className={styles.voucherThemeRow}>
      <td>{data.id}</td>
      <td>{data.name || 'N/A'}</td>
      <td>{data.voucherThemeCategory.name || 'N/A'}</td>
      <td>
        {renderVoucherThemeImageCell
          ? renderVoucherThemeImageCell(data.imageFront)
          : null}
      </td>
      <td>
        {renderVoucherThemeImageCell
          ? renderVoucherThemeImageCell(data.imageBack)
          : null}
      </td>
      <td>
        {renderExpandableText
          ? renderExpandableText(data.smsContent, data.id, 'sms')
          : data.smsContent}
      </td>
      <td>
        {renderExpandableText
          ? renderExpandableText(
            data.emailContent?.replace(/<[^>]+>/g, ''),
            data.id,
            'email'
          )
          : data.emailContent}
        {handleEditVoucherTheme && (
          <div
            className={styles.editIconContainer}
            onClick={(e) => {
              e.stopPropagation();
              handleEditVoucherTheme(data);
            }}
          >
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id={`tooltip-edit-${data.id}`}>Edit</Tooltip>}
            >
              <span>
                <FontAwesomeIcon icon={faEdit} />
              </span>
            </OverlayTrigger>
          </div>
        )}
      </td>
    </tr>
  );

  const renderRedemptionsData = (data) => (
    <tr key={data.id}>
      <td>{data.id}</td>
      <td>
        {data.merchantEarning &&
          data.merchantEarning
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      </td>
    </tr>
  );

  const renderSubMerchantData = (data) => (
    <tr key={data.id}>
      <td>{data.id}</td>
      <td>{data.emails.join(', ')}</td>
      <td>{data.mobileNumber.join(', ')}</td>
      <td>{data.location}</td>
      <td style={{ width: '10px' }}>
        {renderTerminalsDropdown(data.terminals)}
      </td>
    </tr>
  );

  const renderMerchantData = (data) => (
    <tr
      className={styles.merchantRow}
      style={{ cursor: 'pointer' }}
      key={data.id}
      onClick={(e) => {
        // Only navigate to merchant details if not clicking the edit icon
        if (!e.target.closest(`.${styles.editIconContainer}`)) {
          handleOnClick(data.id);
        }
      }}
    >
      <td>{data.id}</td>
      <td>{data.name}</td>
      <td>{data.category}</td>
      <td>{data.status}</td>
      <td>{data.website}</td>
      <td style={{ position: 'relative' }}>
        {data.tel}
        {handleEditMerchant && (
          <div
            className={styles.editIconContainer}
            style={{ cursor: 'pointer', position: 'absolute', right: '10px' }}
            onClick={(e) => {
              e.stopPropagation();
              handleEditMerchant(data);
            }}
          >
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id={`tooltip-edit-${data.id}`}>Edit</Tooltip>}
            >
              <span>
                <FontAwesomeIcon icon={faEdit} />
              </span>
            </OverlayTrigger>
          </div>
        )}
      </td>
    </tr>
  );

  const renderMerchantGroupData = (data) => {
    return (
      <tr className={styles.merchantRow} key={data.id}>
        <td onClick={() => handleOnClick(data.id)}>{data.id}</td>
        <td onClick={() => handleOnClick(data.id)}>{data.name ? data.name : 'N/A'}</td>
        <td onClick={() => handleOnClick(data.id)}>{data.description ? data.description : 'N/A'}</td>
        <td>
          {data.merchants && data.merchants.length > 0
            ? data.merchants.map((merchant) => merchant.name).join(', ')
            : 'N/A'}
          <div
            className={styles.editIconContainer}
            onClick={(e) => {
              e.stopPropagation();
              handleEditMerchant(data);
            }}
          >
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id={`tooltip-edit-${data.id}`}>Edit</Tooltip>}
            >
              <span>
                <FontAwesomeIcon icon={faEdit} />
              </span>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    );
  }

  const renderTerminalData = (data) => (
    <tr onClick={() => handleOnClick(data.id)} key={data.id}>
      <td>{data.id}</td>
      <td>{data.merchant.name}</td>
      <td>{data.subMerchant.id}</td>
      <td>{data.lastActive}</td>
    </tr>
  );

  const renderPaymentData = (data) => {
    return (
      <tr onClick={() => handleOnClick(data.id)} key={data.id}>
        <td>{moment(data.createdTimestamp).format('DD/MM/YYYY hh:mm A')}</td>
        {!merchant && <td>{data.id}</td>}
        <td>{data.referenceCode}</td>
        {!merchant && <td>{data.coreMerchant.name}</td>}
        <td>
          <span className='d-flex justify-content-end w-50'>
            {data.amount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </span>
        </td>
      </tr>
    );
  };

  const renderClientOrder = (data) => (
    <tr onClick={() => handleOnClick(data.clientOrderId)} key={data.id}>
      <td>{data.clientOrderId}</td>
      <td>{data.referenceNo}</td>
      <td>{moment(data.date).format('DD/MM/YYYY hh:mm A')}</td>
      <td>{data.client.clientName}</td>
      <td>{data.totalAmount}</td>
    </tr>
  );

  const renderClientOrderItems = (data) => {
    const handleSave = (field, newValue) => {
      console.log(`Updated ${field} to ${newValue} for item ID ${data.id}`);
    };

    return (
      <tr key={data.id}>
        <EditableCell
          value={data.amount && data.amount.toFixed(2)}
          onSave={(newValue) => handleSave('amount', newValue)}
        />
        <EditableCell
          value={data.qty}
          onSave={(newValue) => handleSave('qty', newValue)}
        />
        <td>
          {' '}
          <OverlayTrigger
            placement='right'
            overlay={<Tooltip id='remove-row-tooltip'>{'Remove Row'}</Tooltip>}
          >
            <button onClick={() => handleRemoveRow(data.id)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </OverlayTrigger>
        </td>
      </tr>
    );
  };

  // Render for invoice details including a grand total row.
  const renderInvoiceDetails = (data) => (
    <tr key={data.id}>
      <td>LKR {data.amount} Multi-Store e-gift card</td>
      <td>{data.qty}</td>
      <td>{data.amount.toFixed(2)}</td>
      <td>{(data.qty * data.amount).toFixed(2)}</td>
    </tr>
  );

  // ==========================
  // Main switch to render rows
  // ==========================
  const renderTableData = () => {
    switch (tag) {
      case 'terminal':
        return safeTableData.map((data) => renderTerminalData(data));
      case 'payments':
        return safeTableData.map((data) => renderPaymentData(data));
      case 'merchants':
        return safeTableData.map((data) => renderMerchantData(data));
      case 'merchant-groups':
        return safeTableData.map((data) => renderMerchantGroupData(data));
      case 'subMerchants':
        return safeTableData.map((data) => renderSubMerchantData(data));
      case 'redemptions':
        return safeTableData.map((data) => renderRedemptionsData(data));
      case 'userDetails':
        return safeTableData.map((data) => renderUserDetails(data));
      case 'adminUsers':
        return safeTableData.map((data) => renderAdminUserData(data));
      case 'voucherDetails':
        return safeTableData.map((data) => renderVoucherDetails(data));
      case 'products':
        return safeTableData.map((data) => renderProductDetails(data));
      case 'product-categories':
        return safeTableData.map((data) => renderProductCategoryDetails(data));
      case 'voucherThemes':
        return safeTableData.map((data) => renderVoucherThemes(data));
      case 'denominationUploads':
        return safeTableData.map((data) => renderUploadHistory(data));
      case 'transactionDetails':
        return safeTableData.map((data) => renderTransactionHistory(data));
      case 'transferred Details':
        return safeTableData.map((data) => renderTransferredData(data));
      case 'clientDetails':
        return safeTableData.map((data) => renderClientOrder(data));
      case 'clientOrderItems':
        return safeTableData.map((data) => renderClientOrderItems(data));
      case 'invoiceDetails': {
        const grandTotal = safeTableData.reduce(
          (acc, item) => acc + item.qty * item.amount,
          0
        );
        return (
          <>
            {safeTableData.map((data) => renderInvoiceDetails(data))}
            <tr>
              <td
                colSpan={3}
                style={{ textAlign: 'center', fontWeight: 'bold' }}
              >
                Grand Total
              </td>
              <td style={{ fontWeight: 'bold' }}>{grandTotal.toFixed(2)}</td>
            </tr>
          </>
        );
      }
      default:
        return null;
    }
  };

  // ==========================
  // Render "no data" or "error" rows
  // ==========================
  const renderNotFound = (content) => (
    <tr>
      <td
        colSpan={safeTableHeading.length}
        className='text-secondary bg-white text-center'
      >
        <span className='py-4'>{content}</span>
      </td>
    </tr>
  );

  // ==========================
  // Final table structure
  // ==========================
  const renderTable = () => (
    <div className='w-100'>
      <Table striped bordered hover>
        <thead>
          <tr>{renderTableHeadings()}</tr>
        </thead>
        <tbody>
          {search_filter_loading ? (
            <tr>
              <td colSpan={safeTableHeading.length} className='text-secondary bg-white text-center'>
                <Spinner animation='border' />
              </td>
            </tr>
          ) : !fetchError && safeTableData.length > 0 ? (
            renderTableData()
          ) : fetchError ? (
            renderNotFound(fetchError)
          ) : (
            renderNotFound(
              notFoundMessage || `NO ${tag?.toUpperCase?.() || 'DATA'} FOUND`
            )
          )}

        </tbody>
      </Table>
      {handleAddRow && (
        <div className='text-center'>
          <button onClick={() => handleAddRow(safeTableData.id)}>
            <FontAwesomeIcon icon={faPlus} /> Add Row
          </button>
        </div>
      )}
    </div>
  );

  return <div className={styles.root__div}>{renderTable()}</div>;
};

export default DataTable;
